import '../../containers/Accordion/Accordion.css'
import './EventLink.css'

const EventLink =(props) =>{
    const _Days = ["א","ב","ג","ד","ה","ו","ש"];
    let eventDate = new Date(props.data.MODNewsPublishDate);
    let monthNum = eventDate.getMonth();
    let year = eventDate.getFullYear();
    let day = eventDate.getDate();
    return(
        <div className="eventLink title modCard-header col-12 col-lg-4" id={"accHead_" + props.WpId +"_"+ props.index} >
            {/* <h3 className="mb-0"> */}
                <a className="btn btn-link" href={props.moreLink +"?itemId="+ props.data.ID+ "&month="+monthNum+"&year="+year} title="לאירוע">
                    <div className="itemTitle">
                        <div className="eventDate">
                        {/* <div className="date">{eventDate.toLocaleDateString('he-IL')}</div> */}
                        <div className="date">{day+"."+(monthNum+1)+"."+ year%100}</div>
                            <div className="dayHour">
                                <div className="title">יום {_Days[eventDate.getDay()]}'</div>
                                <div className="hour"><span>{props.data.ModHour} </span></div>
                            </div>
                        </div>
                        <div className="titleWrap">
                            <p className="title">{props.data.Title}</p>
                        </div>
                    </div>
                </a>
            {/* </h3>  */}
        </div>
    )
}
export default EventLink